import { useEffect, useRef } from 'react';

import { FAQ } from '@components/FAQ';
import { AccordionChangeHandler } from '@components/FAQ/types';
import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import {
  useTrackSignupBroadbandFaqExpanded,
  useTrackSignupBroadbandFaqsDisplayedOnce,
} from '@tracking/trackingEvents';

import { faqSections } from './sections';

const BroadbandFAQ: React.FC = () => {
  const faqRef = useRef<HTMLHeadingElement>(null);
  const isInView = useIsInView(faqRef);
  const { trackingContexts } = useTrackingContext();
  const trackQuestion = useTrackSignupBroadbandFaqExpanded();
  const trackFaqsDisplayed = useTrackSignupBroadbandFaqsDisplayedOnce();

  useEffect(() => {
    if (isInView) {
      trackFaqsDisplayed({}, { contexts: trackingContexts });
    }
  }, [isInView, trackFaqsDisplayed, trackingContexts]);

  const trackQuestionExpanded = (question: string) => {
    trackQuestion(
      {
        question,
      },
      { contexts: trackingContexts }
    );
  };

  const handleAccordionChange: AccordionChangeHandler = (
    question,
    isExpanded
  ) => {
    if (isExpanded) {
      trackQuestionExpanded(question);
    }
  };

  return (
    <FAQ
      sections={faqSections}
      onAccordionChange={handleAccordionChange}
      ref={faqRef}
    />
  );
};

export { BroadbandFAQ };
